class BulkPayCommissionTrackersReq {
  constructor() {
    this.commissionTrackerIds = [];
    this.amounts = {};
  }
}

export default BulkPayCommissionTrackersReq;